// extracted by mini-css-extract-plugin
module.exports = {"breakpointMedium":"500px","breakpointLarge":"790px","breakpointSticky":"500px","flyout":"flyout__1ngyW","flyoutInner":"flyoutInner__1kgSG","arrow":"arrow__1z_uS"};